import React from "react";
import { Disclosure } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { useLocation } from "react-router-dom";
import logo from "../../assets/mobstrlogowide.png";

function HeaderContent() {
  const location = useLocation();
  const isTeamsAppsPage = location.pathname.startsWith('/teams-apps');

  return (
    <div className="flex-shrink-0 flex items-center">
      <img className="w-36 sm:w-40" src={logo} alt="Mobstr" />
      {isTeamsAppsPage ? (
        <img
          className="hidden sm:block sm:ml-6 sm:pl-6 sm:border-l sm:border-slate-200 h-9"
          src="/opengateslogo.png"
          alt="OpenGates"
        />
      ) : (
        <span className="hidden sm:block ml-6 pl-6 border-l border-slate-200 text-sm text-slate-500">
          <span className="font-semibold text-slate-800">App Intelligence</span>
          <span className="mx-1.5 text-slate-300">/</span>
          Security Scanning
        </span>
      )}
    </div>
  );
}

function initialsOf(user) {
  const source = user?.name || user?.email || "";
  const parts = source.split(/[\s@._-]+/).filter(Boolean);
  return parts.slice(0, 2).map((p) => p[0].toUpperCase()).join("") || "?";
}

function UserChip({ user }) {
  if (!user || typeof user !== "object") return null;
  const orgName = user.organization?.name;
  return (
    <div className="hidden sm:flex items-center gap-3" data-testid="header-user">
      <div className="text-right leading-tight">
        {orgName && <div className="text-sm font-semibold text-slate-800">{orgName}</div>}
        {user.email && <div className="text-xs text-slate-500">{user.email}</div>}
      </div>
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-mobstr-navy text-xs font-semibold text-white ring-2 ring-white shadow">
        {initialsOf(user)}
      </span>
    </div>
  );
}

export default function AppHeader({ userLoggedIn, isOpen, toggleSidebar }) {
  return (
    <Disclosure as="nav" className="sticky top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="max-w-full mx-auto px-4 sm:px-6">
        <div className="relative flex items-center justify-between h-16">
          {userLoggedIn && (
            <div className="absolute inset-y-0 left-0 flex items-center md:hidden">
              <Disclosure.Button
                className="inline-flex items-center justify-center p-2 rounded-md text-slate-500 hover:text-slate-900 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-mobstr-purple"
                onClick={toggleSidebar}
              >
                <span className="sr-only">Open main menu</span>
                {isOpen ? (
                  <XIcon className="block h-6 w-6" aria-hidden="true" />
                ) : (
                  <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                )}
              </Disclosure.Button>
            </div>
          )}
          <div className="flex-1 flex items-center justify-center sm:justify-start">
            <HeaderContent />
          </div>
          <UserChip user={userLoggedIn} />
        </div>
      </div>
    </Disclosure>
  );
}
